export default __webpack_public_path__ + "static/media/Undertake Prescript.192997e8.png";